import { render, staticRenderFns } from "./DialogMasterCopy.vue?vue&type=template&id=0b39a32c&"
import script from "./DialogMasterCopy.vue?vue&type=script&lang=ts&"
export * from "./DialogMasterCopy.vue?vue&type=script&lang=ts&"
import style0 from "./DialogMasterCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogMasterCopy.vue"
export default component.exports